// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SmallSeat_mainContainer__33wSy"};